import { Box, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const HeaderGptSection = ({ name }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.white.main,
        display: "flex",
        justifyContent: "space-between",
        height: "82px",
        borderBottom: "2px solid",
        borderColor: theme.palette.black.main,
        overflowX: "hidden",
        padding: "14px 20px 20px 12px",

        borderRadius: "16px 16px 0px 0px",
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 3,
      }}
    >
      <Box>
        <Typography sx={{ fontSize: "16px", lineHeight: "24px" }}>
          Ask Chat GPT about
        </Typography>
        <Typography sx={{ fontWeight: 600, fontSize: "24px" }}>
          {name}
        </Typography>
      </Box>

      <Box
        onClick={() => navigate(-1)}
        sx={{
          display: "flex",
          alignItems: "start",
          cursor: "pointer",
          pt: "5px",
        }}
      >
        <CloseRoundedIcon />
      </Box>
    </Box>
  );
};

export default HeaderGptSection;
